(async function () {
  const PAGES = [
    "lp-265-sem",
    "lp-265-sns",
    "lp-265-newsletter",
    "lp-265-dm",
    "lp-265-flyer",
    "lp-2205-265",
    "lp-2206-265-c",
    "lp-2206-265-a",
    "lp-2206-265-b",
    "lp-2208-a"
  ]

  const NEWSLETTER_SOURCES = [
    'newsletter',
    'newletter1',
    'newletter2',
    'flyer',
    'flyer1',
    'flyer2',
    'newsletter-265-1',
    'newsletter-265-2',
    'newsletter-567-1',
    'newsletter-567-2',
    'newsletter-20-1',
    'newsletter-20-2',
    'nhs35off',
    'nhs20',
    'lp-chocolate-hb2310',
    'lp-120-hb2507',    
    'lp-pouch-hb2407'
  ]

  const params = new URLSearchParams(document.location.search.substring(1));
  const landingPage = params.get("lps");
  const source = params.get("source");
  const quantity = parseInt(params.get("quantity") || "1");

  if (PAGES.includes(landingPage)) {
    const maskEl = document.createElement("div")
    maskEl.innerHTML = '<div style="position: absolute; width: 100vw; height: 100vh; top: 0; background-color: white; z-index: 999;"></div>'
    document.body.appendChild(maskEl)

    let id
    if (params.get("variant")){
      id = params.get("variant")
    } else {
      const PROD_VARIANT_ID = NEWSLETTER_SOURCES.includes('nhs20') ? 42722743845035 : 40481293009076;
      const STG_VARIANT_ID = 40481293009076
      const STG_HOST = 'nestlehealthscience-japan-stg-plus.myshopify.com'
      const isStg = window.location.host === STG_HOST
      id = isStg ? STG_VARIANT_ID : PROD_VARIANT_ID
    }
    let formData = {
      attributes: {
        __source: landingPage,
      },
      items: [
        {
          quantity,
          id,
          properties: {
            __source: landingPage
          }
        }
      ]
    }

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      console.log(response.json())
      window.location.href = "/cart"
      // return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  if (NEWSLETTER_SOURCES.includes(source)) {
    const maskEl = document.createElement("div")
    maskEl.innerHTML = '<div style="position: absolute; width: 100vw; height: 100vh; top: 0; background-color: white; z-index: 999;"></div>'
    document.body.appendChild(maskEl)

    const selling_plan = params.get("selling_plan")
    const id = params.get("variant")

    let formData = {
      attributes: {
        __source: source,
      },
      items: [
        {
          quantity,
          selling_plan,
          id,
          properties: {
            __source: source
          }
        }
      ]
    }

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      console.log(response.json())
      window.location.href = "/cart/checkout"
      // return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
})();
